/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Container } from './components/Container'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalEditar } from './components/ModalEditar'
import { iItemDashResponse } from '../..'

export interface iAcaoRecomendacao {
  id: string
  competenciaId: string
  titulo: string
  icone: string
  oqueFazer: string
  comoFazer: string
  porqueFazer: string
}

interface iProps {
  recomendacoes: iAcaoRecomendacao[]
  item: iItemDashResponse
  acaoEdit?: iAcaoRecomendacao
  onGerarRecomendacoes: () => void
  onSalvar: (acao: iAcaoRecomendacao) => void
  onRefresh: (id: string) => void
  GerarAcoesPorRecomendacoes: (item: iItemDashResponse) => void
  isLoadingAcao: boolean
}

export const TabRecomendacao: React.FC<iProps> = ({ item, GerarAcoesPorRecomendacoes, recomendacoes, onGerarRecomendacoes, onRefresh, onSalvar, acaoEdit, isLoadingAcao }) => {
  // const toast = useToast()

  const [ModalIsOpen, setModalIsOpen] = useState(false)

  const [Acao, setAcao] = useState<iAcaoRecomendacao>()

  function onCloseModal(): void {
    setModalIsOpen(false)
    setAcao(undefined)
  }

  function onOpenModal(acao: iAcaoRecomendacao): void {
    setModalIsOpen(true)
    setAcao(acao)
  }

  // function Salvar(acao: iAcao): void {
  //   const pos = Arr.findIndex(e => e.acao === acao.acao)
  //   if (pos === -1) {
  //     return
  //   }
  //   appApi.post(`AvaliacaoPesquisa/${avaliacaoId}/Acao/${pos}`, acao)
  //     .then(() => {
  //       toast({
  //         title: 'Ação alterada com sucesso!',
  //         status: 'success',
  //         isClosable: false,
  //         position: 'top-right',
  //         duration: 4000
  //       })
  //       setArr(UpdateElementByPosition([...Arr], pos, acao))
  //       onCloseModal()
  //     })
  //     .catch(err => {
  //       console.log(err)
  //       toast({
  //         title: 'Erro ao alterar a ação, tente novamente!',
  //         status: 'error',
  //         isClosable: false,
  //         position: 'top-right',
  //         duration: 4000
  //       })
  //     })
  // }

  // function Refresh(nome: string): void {
  //   const posRecomendacao = Arr.findIndex(e => e.acao === nome)
  //   if (posRecomendacao === -1) {
  //     return
  //   }
  //   appApi.get(`AvaliacaoPesquisa/${avaliacaoId}/Acao?posicao=${posRecomendacao + 1}`)
  //     .then((e) => {
  //       if (e.status === 200) {
  //         const data: iAcao = e.data
  //         setAcao({
  //           ...Acao,
  //           acao: Acao?.acao ?? '',
  //           comoFazer: data.comoFazer,
  //           oqueFazer: data.oqueFazer,
  //           porqueFazer: data.porqueFazer,
  //           icone: data.icone
  //         })
  //         toast({
  //           title: 'Ação refeita com sucesso!',
  //           status: 'success',
  //           isClosable: false,
  //           position: 'top-right',
  //           duration: 4000
  //         })
  //       }
  //     })
  //     .catch(err => {
  //       console.log(err)
  //       toast({
  //         title: 'Erro ao recarregar a ação, tente novamente!',
  //         status: 'error',
  //         isClosable: false,
  //         position: 'top-right',
  //         duration: 4000
  //       })
  //     })
  // }

  function ObterTextoRecomendacoes(): any {
    if (recomendacoes.length === 1) {
      return <strong>“{recomendacoes[0].titulo}”, </strong>
    } else {
      return (
        <span>
          {recomendacoes.map((e, i) => {
            if (recomendacoes.length - 2 === i) {
              return (
                <strong key={i}>“{e.titulo}” <span style={{ fontWeight: 'normal' }}>e</span> </strong>
              )
            } else {
              return (
                <strong key={i}>“{e.titulo}”, </strong>
              )
            }
          })}
        </span>
      )
    }
  }

  useEffect(() => {
    if (!acaoEdit) {
      setModalIsOpen(false)
    }

    setAcao(acaoEdit)
  }, [acaoEdit])

  return (
    <Flex flexDir={'column'} gap='.75rem'>

      {ModalIsOpen &&
        <ModalEditar
          model={Acao}
          onClose={onCloseModal}
          onSave={onSalvar}
          onRefresh={onRefresh}
          isLoadingAcao={isLoadingAcao}
        />
      }
      <Flex alignItems='center' justifyContent={'space-between'}>
        <Flex gap={'.25rem'} flexDir='column' lineHeight={'1rem'}>
          <Text
            fontSize={'1rem'}
            bgClip='text'
            bgGradient={'var(--DegradeAzul)'}
            fontWeight={'700'}
          >Estas recomendações são geradas por inteligência artificial</Text>

          <Text fontSize='.875rem'>Considerando as competências de {ObterTextoRecomendacoes()} nós geramos uma recomendações para seu plano de desenvolvimento pessoal.</Text>
        </Flex>

        <Flex gap={'.5rem'}>
          {item.itensATrabalhar?.competencias && item.itensATrabalhar?.competencias.length > 0 && <ButtonCmp isDisabled={!item.pdi?.canEdit || !item.itensATrabalhar.recomendacoes || item.itensATrabalhar.recomendacoes?.length === 0} onClick={() => GerarAcoesPorRecomendacoes(item)} VarColor='Green2'>Gerar ações com base nas recomendações</ButtonCmp>}
          <ButtonCmp onClick={onGerarRecomendacoes} VarColor='Rosa'>Gerar novas recomendações por IA</ButtonCmp>
        </Flex>
      </Flex>
      <Flex flexDir={'column'} gap={'1rem'}>
        {recomendacoes.map((e, i) => {
          return (
            <Container
              key={i}
              model={e}
              index={i + 1}
              onEdit={onOpenModal}
            />
          )
        })}
      </Flex>

      <Flex gap={'.75rem'} flexDir={'column'}>
        <Flex textAlign={'center'} gap={'.5rem'} flexDir={'column'}>
          <Text
            fontSize={'.95rem'}
            fontWeight={'700'}
            color={'var(--Roxo)'}
          >Estamos confiantes de que estas ações irão impulsionar o seu crescimento e contribuição ainda mais.
            Juntos, estamos construindo um futuro de sucesso.
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}
